module.exports = __webpack_public_path__ + "media/music/saw_lead_6-1b87bcb9.mp3";